<template>
  <div v-if="radio.show" class="custom-radio-wrapper">
    <div :class="radio_class" @click="radio.active = !radio.active">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomRadio',
  props: [
    'radio'
  ],
  computed: {
    radio_class () {
      return this.radio.active ? 'custom-radio active' : 'custom-radio'
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-radio-wrapper {
  
  .custom-radio {
    width: 16px;
    height: 16px;
    border: 2px solid #FF4402;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .custom-radio.active {
    border: 5px solid #FF4402;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom_ui_components/CustomRadio.vue